import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
	selector: "deposit-end-screen-wrapper",
	templateUrl: "./deposit-common-end-screen.component.html",
	styleUrls: ["./deposit-common-end-screen.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class DepositCommonEndScreenComponent {}
